import api from "./client";
const BASE = "/pinned-students";

export async function fetchPinnedStudents(filters = {}) {
  const { data } = await api.get(BASE);

  return data || [];
}

export async function togglePinnedStudent(email) {
  const { data } = await api.post(`${BASE}/toggle`, {
    email,
  });

  return data;
}
